module.exports = __webpack_public_path__ + "img/1557614080776282114.29e6855d.png";